import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, TrendingUp, Users } from 'lucide-react';
export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-32 pb-20 md:pt-40 md:pb-32 bg-warm-white px-6 overflow-hidden" data-id="element-113">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center" data-id="element-114">
        {/* Left Column - Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-3" data-id="element-115">
          <span className="inline-block text-sage font-semibold tracking-wider text-xs uppercase mb-4" data-id="element-116">
            Indexed Universal Life Specialist
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-[56px] leading-[1.1] font-bold text-forest mb-6" data-id="element-117">
            Market Upside. <br data-id="element-118" />
            Zero Downside. <br data-id="element-119" />
            <span className="text-copper" data-id="element-120">Tax-Free Retirement Wealth.</span>
          </h1>

          <p className="text-charcoal text-lg md:text-xl leading-relaxed mb-8 max-w-xl" data-id="element-121">
            Protect your family while growing tax-free cash value you can access
            with Indexed Universal Life Insurance.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6" data-id="element-122">
            <button onClick={scrollToContact} className="w-full sm:w-auto bg-copper text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#A6683C] transition-all hover:-translate-y-0.5 hover:shadow-lg flex items-center justify-center gap-2" data-id="element-123">
              Get Your Free IUL Quote
              <ArrowRight size={20} data-id="element-124" />
            </button>
          </div>

          <p className="text-sage text-sm font-medium flex items-center gap-2" data-id="element-125">
            <ShieldCheck size={16} className="text-sage" data-id="element-126" />
            No obligation · Licensed guidance · Customized to your goals
          </p>
        </motion.div>

        {/* Right Column - Trust Card */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="lg:col-span-2" data-id="element-127">
          <div className="bg-white p-8 rounded-2xl shadow-soft border border-gray-100 relative z-10" data-id="element-128">
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-cream rounded-full -z-10 opacity-50" data-id="element-129"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-forest/5 rounded-full -z-10" data-id="element-130"></div>

            <span className="text-copper font-bold text-xs tracking-wider uppercase mb-3 block" data-id="element-131">
              Confident, Tax-Efficient Planning
            </span>

            <p className="text-charcoal text-lg leading-relaxed mb-6 font-medium" data-id="element-132">
              Xander Winther specializes in Indexed Universal Life strategies
              for professionals and families seeking predictable protection and
              flexible, tax-advantaged cash value for retirement.
            </p>

            <div className="pt-6 border-t border-gray-100" data-id="element-133">
              <div className="flex flex-wrap gap-2 text-sm text-sage font-medium" data-id="element-134">
                <span className="flex items-center gap-1" data-id="element-135">
                  <span className="w-1.5 h-1.5 rounded-full bg-forest" data-id="element-136"></span>
                  Licensed in multiple states
                </span>
                <span className="flex items-center gap-1" data-id="element-137">
                  <span className="w-1.5 h-1.5 rounded-full bg-forest" data-id="element-138"></span>
                  Independent advisor
                </span>
                <span className="flex items-center gap-1" data-id="element-139">
                  <span className="w-1.5 h-1.5 rounded-full bg-forest" data-id="element-140"></span>
                  Access to leading IUL carriers
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}